class CollectionShowcaseCarousel extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.collection-showcase');
    this.tabs = this.section ? this.section.querySelectorAll('.collection-showcase__tab') : [];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });

    this.querySelectorAll('.collection-showcase__panel').forEach((panel) => {
      const prev = panel.querySelector('.collection-showcase__arrow--prev');
      const next = panel.querySelector('.collection-showcase__arrow--next');
      const track = panel.querySelector('.collection-showcase__track');
      if (!track) return;

      if (prev) {
        prev.addEventListener('click', () => {
          const atStart = track.scrollLeft <= 1;
          if (atStart) {
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
          }
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
          if (atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
          }
        });
      }
    });
  }

  selectTab(activeTab) {
    const index = activeTab.dataset.tabIndex;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('.collection-showcase__panel').forEach((panel) => {
      const isActive = panel.dataset.tabPanel === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

customElements.define('collection-showcase-carousel', CollectionShowcaseCarousel);
